import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=2fb4e263&scoped=true&"
import script from "./UserInvite.vue?vue&type=script&lang=js&"
export * from "./UserInvite.vue?vue&type=script&lang=js&"
import style0 from "./UserInvite.vue?vue&type=style&index=0&id=2fb4e263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4e263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb4e263')) {
      api.createRecord('2fb4e263', component.options)
    } else {
      api.reload('2fb4e263', component.options)
    }
    module.hot.accept("./UserInvite.vue?vue&type=template&id=2fb4e263&scoped=true&", function () {
      api.rerender('2fb4e263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/forms/UserInvite.vue"
export default component.exports